import axios from "axios";
import {getCookie} from "shared/networking/tools";

const csrfToken = getCookie('csrftoken');


const baseApi = axios.create({
    baseURL: '/',
    headers: {
        'X-CSRFToken': csrfToken
    }
})

export default baseApi;
